/**
 * Debe importarse primero en index.tsx.
 * Producción: silencia console.* (los logs en código siguen existiendo).
 * Desarrollo: filtra el ruido conocido de ResizeObserver.
 */
if (process.env.NODE_ENV === 'production') {
  const noop = (): void => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
} else {
  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

export {};
